import { Navigate } from 'react-router-dom';
import { getUserRole } from '../api/github';

export default function PrivateRoute({ children, requiredRole }) {
  const isAuth = localStorage.getItem('isAuth') === 'true';
  const userRole = localStorage.getItem('userRole');

  if (!isAuth) return <Navigate to="/" />; // Не авторизован → на вход
  if (requiredRole && userRole !== requiredRole) return <Navigate to="/employee" />; // Роль не подходит
  
  return children; // Доступ разрешён
}